import { cn } from '@/utils';
import * as ScrollAreaPrimitive from '@radix-ui/react-scroll-area';
import * as React from 'react';

const ScrollArea = React.forwardRef(({ className, children, ...props }, ref) => (
    <ScrollAreaPrimitive.Root
        className={cn('tw-relative tw-overflow-hidden', className)}
        ref={ref}
        {...props}>
        <ScrollAreaPrimitive.Viewport className="tw-h-full tw-w-full tw-rounded-[inherit]">
            {children}
        </ScrollAreaPrimitive.Viewport>
        <ScrollBar/>
        <ScrollAreaPrimitive.Corner/>
    </ScrollAreaPrimitive.Root>
));
ScrollArea.displayName = ScrollAreaPrimitive.Root.displayName;

const ScrollBar = React.forwardRef(({ className, orientation = 'vertical', ...props }, ref) => (
    <ScrollAreaPrimitive.ScrollAreaScrollbar
        className={cn(
            'tw-flex tw-touch-none tw-select-none tw-transition-colors',
            orientation === 'vertical' &&
                        'tw-h-full tw-w-2.5 tw-border-l tw-border-l-transparent tw-p-[1px]',
            orientation === 'horizontal' &&
                        'tw-h-2.5 tw-flex-col tw-border-t tw-border-t-transparent tw-p-[1px]',
            className
        )}
        orientation={orientation}
        ref={ref}
        {...props}>
        <ScrollAreaPrimitive.ScrollAreaThumb className="tw-relative tw-flex-1 tw-rounded-full tw-bg-border"/>
    </ScrollAreaPrimitive.ScrollAreaScrollbar>
));
ScrollBar.displayName = ScrollAreaPrimitive.ScrollAreaScrollbar.displayName;

export { ScrollArea, ScrollBar };
